module.exports = __webpack_public_path__ + "static/media/webscript.e7dde40e.svg";